import { Chip } from '@mui/material';

/**
 * StateChip - Displays the current state of an NFT
 *
 * Supports two input formats:
 * 1. Direct state prop (uppercase): 'MINTED', 'ACTIVATED', 'USED', 'EXPIRED'
 * 2. lockDetails prop: Object with stateName field from contract handler
 *
 * @param {Object} props
 * @param {string} [props.state] - Direct state value (uppercase)
 * @param {Object} [props.lockDetails] - Lock details from contract handler
 * @param {string} [props.size='small'] - Chip size ('small' or 'medium')
 */
const StateChip = ({ state, lockDetails, size = 'small' }) => {
  const stateConfig = {
    MINTED: { label: 'Inactive', color: 'default' },
    ACTIVATED: { label: 'Active', color: 'success' },
    USED: { label: 'Used', color: 'info' },
    EXPIRED: { label: 'Expired', color: 'error' },
  };

  // Support both direct state and lockDetails prop
  // If lockDetails provided, derive state from stateName
  // IMPORTANT: isExpired takes priority - expired tokens can't be activated/transferred
  let displayState = state;
  if (!displayState && lockDetails) {
    if (lockDetails.isExpired) {
      displayState = 'EXPIRED';
    } else if (lockDetails.stateName) {
      // For NFTs that don't require activation, Minted = Active
      // This includes: "Expirable Only" and "Standard" (neither activatable nor expirable)
      // Only apply when isActivatable is explicitly false (not undefined)
      if (lockDetails.stateName === 'Minted' && lockDetails.isActivatable === false) {
        displayState = 'ACTIVATED'; // Show as Active
      } else {
        displayState = lockDetails.stateName.toUpperCase();
      }
    }
  }

  if (!displayState || !stateConfig[displayState]) return null;

  const config = stateConfig[displayState];
  return <Chip label={config.label} color={config.color} size={size} />;
};

export default StateChip;
